import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/vid.mp4'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "parallaxWrapper" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  muted: "",
  loop: "",
  class: "video"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Imprint = _resolveComponent("Imprint")!
  const _component_Privacy = _resolveComponent("Privacy")!
  const _component_Start = _resolveComponent("Start")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_About = _resolveComponent("About")!
  const _component_Product = _resolveComponent("Product")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_Menu)
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "content" }, {
        default: _withCtx(() => [
          (_ctx.showImprint)
            ? (_openBlock(), _createBlock(_component_Imprint, {
                key: 0,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showImprint = false))
              }))
            : _createCommentVNode("", true),
          (_ctx.showPrivacy)
            ? (_openBlock(), _createBlock(_component_Privacy, {
                key: 1,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPrivacy = false))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, {
            id: "start",
            class: "startRow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Start)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            id: "about",
            class: "whiteRow aboutRow textRow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_About, { aboutText: _ctx.aboutText }, null, 8, ["aboutText"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "transitionRow" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            id: "product",
            class: "grayRow textRow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Product, {
                productText: _ctx.productText,
                availableText: _ctx.availableText
              }, null, 8, ["productText", "availableText"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            id: "contact",
            class: "whiteRow textRow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Contact)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "grayRow" }, {
            default: _withCtx(() => [
              _createVNode(_component_Footer, { onFooterClicked: _ctx.footerClicked }, null, 8, ["onFooterClicked"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}